/**
 * Stack dei layer sovrapposti (menu, drawer, modale) del Centro Ticket V3.
 *
 * Serve a un solo scopo: quando piu layer sono aperti insieme (es. la modale
 * "Nuovo ticket" con dentro un menu, o il drawer contesto sopra la coda),
 * Escape deve chiudere SOLO quello piu in alto. Ogni layer si registra
 * all'apertura e controlla `isTopLayer` prima di reagire al tasto.
 *
 * Allo stesso stack e agganciato il blocco dello scroll del body: viene
 * applicato quando entra il primo layer bloccante e rimosso quando esce
 * l'ultimo, cosi due layer annidati non si rubano il ripristino.
 */

export type LayerId = symbol;

let stack: LayerId[] = [];
let locking: LayerId[] = [];
let previousBodyOverflow: string | null = null;

export const pushLayer = (id: LayerId, lockScroll = false): void => {
  if (!stack.includes(id)) stack.push(id);
  if (!lockScroll) return;
  if (!locking.includes(id)) locking.push(id);
  if (locking.length === 1 && typeof document !== 'undefined') {
    previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
};

export const popLayer = (id: LayerId): void => {
  stack = stack.filter((s) => s !== id);
  const wasLocking = locking.includes(id);
  locking = locking.filter((s) => s !== id);
  if (wasLocking && locking.length === 0 && typeof document !== 'undefined') {
    document.body.style.overflow = previousBodyOverflow || '';
    previousBodyOverflow = null;
  }
};

export const isTopLayer = (id: LayerId): boolean =>
  stack.length > 0 && stack[stack.length - 1] === id;

export const layerDepth = (): number => stack.length;

/** Solo per i test: azzera lo stack fra un caso e l'altro. */
export const resetLayers = (): void => {
  stack = [];
  locking = [];
  if (previousBodyOverflow !== null && typeof document !== 'undefined') {
    document.body.style.overflow = previousBodyOverflow;
  }
  previousBodyOverflow = null;
};
